import {dispatch, EVENT_ID} from '../../../containers/event_manager';
import {PERMISSION_TYPE} from '../../../Permissions';
import {hasPermission} from '../../../forecast-app/shared/util/PermissionsUtil';
import Util from '../../../forecast-app/shared/util/util';

const createDefaultEyeOptions = isUsingProjectAllocation => {
	let eyeOptions = [];
	if (!isUsingProjectAllocation && hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS)) {
		eyeOptions.push({name: 'unassigned-tasks', checked: true, translationId: 'scheduling.show_unassigned_tasks'});
	}
	if (hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS)) {
		eyeOptions.push({name: 'company-utilization', checked: true, translationId: 'scheduling.total_resource_utilization'});
	}
	eyeOptions.push({name: 'show-weekends', checked: true, translationId: 'scheduling.show_weekends'});
	eyeOptions.push({
		name: 'show-heatmap',
		checked: true,
		translationId: 'scheduling.show_heatmap',
		openRight: false,
		nestedOptions: [
			{name: 'overbooked-numbers', checked: true, translationId: isUsingProjectAllocation ? 'scheduling.hours_on_over_allocated' : 'scheduling.hours_on_over_assigned'},
			{name: 'available-numbers', checked: true, translationId: isUsingProjectAllocation ? 'scheduling.hours_on_under_allocated' : 'scheduling.hours_on_under_assigned'},
			{name: 'empty-days-numbers', checked: true, translationId: isUsingProjectAllocation ? 'scheduling.hours_on_not_allocated' : 'scheduling.hours_on_not_assigned'},
			{name: 'show-projects', checked: true, translationId: 'scheduling.project_grouping'},
		],
	});
	return eyeOptions;
};

export const getPeopleEyeOptions = isUsingProjectAllocation => {
	const peopleSchedulingDetailSelectorOptions = createDefaultEyeOptions(isUsingProjectAllocation);
	const localStoragePeopleSchedulingDetailSelectorOptions = JSON.parse(localStorage.getItem('canvas-people-scheduling-layout-options-v0.3'));
	if (localStoragePeopleSchedulingDetailSelectorOptions && localStoragePeopleSchedulingDetailSelectorOptions.length) {
		for (const option of peopleSchedulingDetailSelectorOptions) {
			const localStorageOption = localStoragePeopleSchedulingDetailSelectorOptions.find(localStorageOption => localStorageOption.name === option.name);
			if (localStorageOption) {
				option.checked = localStorageOption.checked;
				if (option.nestedOptions) {
					option.nestedOptions.forEach(nestedOption => {
						if (localStorageOption.nestedOptions) {
							const localStorageNestedOption = localStorageOption.nestedOptions.find(localStorageNestedOption => localStorageNestedOption.name === nestedOption.name);
							if (localStorageNestedOption) {
								nestedOption.checked = localStorageNestedOption.checked;
							}
						}
					});
				}
			}
		}
	}

	return peopleSchedulingDetailSelectorOptions;
};

export const handleLayoutDetailSelect = (pageComponent, selected) => {
	const stateDisplay = pageComponent.state.peopleSchedulingDetailSelectorOptions.slice();
	let column = stateDisplay.find(column => column.name === selected.name);
	if (column) {
		if (column.nestedOptions) {
			column.nestedOptions.forEach(option => {
				option.checked = !column.checked;
			});
		}
	}
	if (!column) {
		for (let i = 0; i < stateDisplay.length; i++) {
			if (stateDisplay[i].nestedOptions) {
				column = stateDisplay[i].nestedOptions.find(column => column.name === selected.name);
				if (column !== undefined) {
					if (!selected.checked) {
						stateDisplay[i].checked = true;
					}
					break;
				}
			}
		}
	}
	if (!column) return;

	column.checked = !column.checked;
	pageComponent.onDetailSelectorChange(column);
	Util.localStorageSetItem(`canvas-people-scheduling-layout-options-v0.3`, JSON.stringify(stateDisplay));
	pageComponent.setState({peopleSchedulingDetailSelectorOptions: stateDisplay, recalculateSteps: selected.name === 'show-weekends'}, () => {
		dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
	});
};
